import { axiosObject } from "../config";

export default function getFormSchema(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/posted_properties/_create";
    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
